module.exports = __webpack_public_path__ + "img/icon30.5655d760.png";